import { render, staticRenderFns } from "./posMemoryChoice.vue?vue&type=template&id=0f4dd498&scoped=true&"
import script from "./posMemoryChoice.vue?vue&type=script&lang=js&"
export * from "./posMemoryChoice.vue?vue&type=script&lang=js&"
import style0 from "./posMemoryChoice.vue?vue&type=style&index=0&id=0f4dd498&prod&scoped=true&lang=css&"
import style1 from "./posMemoryChoice.vue?vue&type=style&index=1&id=0f4dd498&prod&lang=css&"
import style2 from "./posMemoryChoice.vue?vue&type=style&index=2&id=0f4dd498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4dd498",
  null
  
)

export default component.exports